import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import Loader from '../ui/Loader';
import { registerUserCode, resetEnvironmentParams } from '../../utils/piction';

function CodeRegisterForm(props) {
  const [QRCode, setQRCode] = useState('');
  const [loginBtn, setButton] = useState('Next');
  const onRegisterClick = () => {
    setButton(<Loader />);
    registerUserCode(props.dispatch)
      .then(res => setQRCode(res.a.qrcode[0]._));
  };
  const onLoginClick = () => {
    resetEnvironmentParams();
    props.dispatch(props.resetLogin());
  };

  return (
    <div className="login__register">
      {QRCode ?
        <div>
          <dev className="login__register-msg">
            <FormattedMessage id="login.scanToLinkMsg" />
          </dev>
          <br />
          <div className="form login__register-info login__register-msg-warning">
            <FormattedMessage id="login.codeDisplayOnceWarning" />
          </div>
          <br />
          <img
            width={250}
            src={QRCode}
            alt="Something went wrong. please contact your IT administrator"
          />
          <br />
          <br />
          <button className="btn btn-primary" onClick={onLoginClick}>
            <FormattedMessage id="login.registerBtn" />
          </button>
        </div>
        :
        <div>
          <dev className="login__register-msg">
            <FormattedMessage id="login.codeRegistryRequired" />
          </dev>
          <br />
          <dev className="login__register-msg">
            <FormattedMessage id="login.codeRegistryMsg" />
          </dev>

          <div className="form login__register-info">
            <FormattedMessage id="login.codeDisplayOnceWarning" />
          </div>
          <br />
          <button className="btn btn-primary" onClick={onRegisterClick}>
            {loginBtn}
          </button>
        </div>
      }
    </div>
  );
}

CodeRegisterForm.propTypes = {
  dispatch: PropTypes.func,
  resetLogin: PropTypes.func,
};

export default injectIntl(CodeRegisterForm);
